<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Parâmetros do Credor/Dados Bancários - Conta CES</h1>
        <b-card title="Dados Gerais do Credor">
            <b-row class="mb-0">
                <b-col sm="12" md="7">
                    <b-form-group
                        label="Nome:"
                        label-for="nome"
                        class="text-label required">
                        <b-form-input v-model="parametros.nome" type="text" id="nome" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.nome.valid ? 'is-invalid' : '')"
                         />
                         
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.nome.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row> 
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="4">
                    <b-form-group
                        label="CNPJ:"
                        label-for="cnpj"
                        class="text-label required">
                        <b-form-input v-model="parametros.cnpj" type="text" id="cnpj" maxlength="18"
                        v-mask="['XX.XXX.XXX/XXXX-##']" 
                        :class="'text-label required ' + (!paymentValidations.cnpj.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.cnpj.valid" class="invalid-message">Preencha com um CNPJ válido.</div>
                         </b-col>
                         </b-row> 
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>
        <b-card title="Endereço do Credor">
            <b-row class="mb-0">
                <b-col sm="12" md="4">
                    <b-form-group
                        label="CEP:"
                        label-for="cep"
                        class="text-label required">
                        <b-form-input v-model="parametros.cep" type="text" id="nome" maxlength="8" 
                        :class="'text-label required ' + (!paymentValidations.cep.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.cep.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row> 
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <b-form-group
                        label="Logradouro:"
                        label-for="endereco"
                        class="text-label required">
                        <b-form-input v-model="parametros.endereco" type="text" id="endereco" maxlength="100" 
                        :class="'text-label required ' + (!paymentValidations.endereco.valid ? 'is-invalid' : '')"
                       />
                       <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.endereco.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                       
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <b-form-group
                        label="Número:"
                        label-for="numero"
                        class="text-label required">
                        <b-form-input v-model="parametros.numero" type="text" id="numero" maxlength="10" 
                        :class="'text-label required ' + (!paymentValidations.numero.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.numero.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group
                        label="Complemento:"
                        label-for="complementoEndereco"
                        class="text-label required">
                        <b-form-input v-model="parametros.complementoEndereco" type="text" id="complementoEndereco" maxlength="50" 
                        :class="'text-label required ' + (!paymentValidations.complementoEndereco.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.complementoEndereco.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="4">
                    <b-form-group
                        label="Bairro:"
                        label-for="bairro"
                        class="text-label required">
                        <b-form-input v-model="parametros.bairro" type="text" id="bairro" maxlength="50" 
                        :class="'text-label required ' + (!paymentValidations.bairro.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.bairro.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>

            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="UF:"
                            label-for="uf"
                            class="text-label required">
                        <b-form-input v-model="parametros.uf" type="text" id="uf" maxlength="2" 
                        :class="'text-label required ' + (!paymentValidations.uf.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.uf.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group
                            label="Município:"
                            label-for="cidade"
                            class="text-label required">
                        <b-form-input v-model="parametros.cidade" type="text" id="cidade" maxlength="50" 
                        :class="'text-label required ' + (!paymentValidations.cidade.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.cidade.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mb-0 mt-4">
                    <b-form-group
                            label="Telefone"
                            label-for="telefone"
                            class="text-label required">
                        <b-form-input id="telefone" type="text" v-model="parametros.telefone"
                                      v-mask="['(##) #####-####', '(##) ####-####']"> 
                                      :class="'text-label required ' + (!paymentValidations.telefone.valid ? 'is-invalid' : '')"
                                      </b-form-input>
                                      
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.telefone.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>

        <b-card title="Dados Bancário">
            <b-row class="mb-0">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Agência:"
                            label-for="agencia"
                            class="text-label required">
                        <b-form-input v-model="parametros.agencia" type="text" id="agencia" maxlength="10" 
                        :class="'text-label required ' + (!paymentValidations.agencia.valid ? 'is-invalid' : '')"
                        
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.agencia.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group
                            label="Digíto Verificador Agência:"
                            label-for="dvAgencia"
                            class="text-label required">
                        <b-form-input v-model="parametros.dvAgencia" type="text" id="dvAgencia" maxlength="2" 
                        :class="'text-label required ' + (!paymentValidations.dvAgencia.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.dvAgencia.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <b-form-group
                            label="Conta Corrente:"
                            label-for="contaCorrente"
                            class="text-label required">
                        <b-form-input v-model="parametros.contaCorrente" type="text" id="contaCorrente" maxlength="15" 
                        :class="'text-label required ' + (!paymentValidations.contaCorrente.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.contaCorrente.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-group
                            label="Digíto Verificador Conta:"
                            label-for="dvContaCorrente"
                            class="text-label required">
                        <b-form-input v-model="parametros.dvContaCorrente" type="text" id="dvContaCorrente" maxlength="2" 
                        :class="'text-label required ' + (!paymentValidations.dvContaCorrente.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.dvContaCorrente.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>

        <b-card title="Dados do Boleto">
            <b-row class="mb-0">
                <b-col sm="12" md="3">
                    <p class="mb-2">
                        Número do Convênio:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Número do Convênio', 'Numero do convenio do Banco do Brasil.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Número do Convênio'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.numeroConvenioBb" type="text" id="numeroConvenioBb" maxlength="10" 
                        :class="'text-label required ' + (!paymentValidations.numeroConvenioBb.valid ? 'is-invalid' : '')"
                        />
                    </b-form-group>
                    <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.numeroConvenioBb.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                </b-col>
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Número Carteira Convênio:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Número Carteira Convênio', 'Numero referente a carteira do convenio com o Banco do Brasil.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Número Carteira Convênio'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.carteiraConvenioBb" type="text" id="carteiraConvenioBb" maxlength="3"
                        :class="'text-label required ' + (!paymentValidations.carteiraConvenioBb.valid ? 'is-invalid' : '')"
                         />
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.carteiraConvenioBb.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Local de Pagamento:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Local de Pagamento', 'Instrução de local de pagamento do boleto bancário.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Local de Pagamento'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.localPagamento" type="text" id="localPagamento" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.localPagamento.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.localPagamento.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <p class="mb-2">
                        Variação da Carteira:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Variação da Carteira', 'Parâmetro de agrupamento de boletos dentro de uma carteira.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Variação da Carteira'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.variacaoCarteira" type="text" id="variacaoCarteira" maxlength="2" 
                        :class="'text-label required ' + (!paymentValidations.variacaoCarteira.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.variacaoCarteira.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Código Modalidade Título:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Modalidade Título', 'Codigo da modalidade utilizada. As modalidades de cobrança possíveis de registro ON LINE são: 1 – Carteira Simples; 4 – Vinculada; 6 – Descontada; 8 – Vendor. Atualmente aceita-se somente modalidade 1.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Modalidade Título'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoModalidadeTituloBb" type="text" id="codigoModalidadeTituloBb" maxlength="4" 
                        :class="'text-label required ' + (!paymentValidations.codigoModalidadeTituloBb.valid ? 'is-invalid' : '')"
                        
                        />
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.codigoModalidadeTituloBb.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 1:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 1', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 1'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto1" type="text" id="instrucaoBoleto1" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto1.valid ? 'is-invalid' : '')"
                        />
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.instrucaoBoleto1.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 2:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 2', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 2'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto2" type="text" id="instrucaoBoleto2" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto2.valid ? 'is-invalid' : '')"
                        />
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.instrucaoBoleto2.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 3:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 3', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 3'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto3" type="text" id="instrucaoBoleto3" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto3.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.instrucaoBoleto3.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 4:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 4', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 4'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto4" type="text" id="instrucaoBoleto4" maxlength="150"
                         :class="'text-label required ' + (!paymentValidations.instrucaoBoleto4.valid ? 'is-invalid' : '')"
                         />
                         <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.instrucaoBoleto4.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 5:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 5', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 5'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto5" type="text" id="instrucaoBoleto5" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto5.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.instrucaoBoleto5.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 6:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 6', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 6'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto6" type="text" id="instrucaoBoleto6" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto6.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                         <b-col sm="12" md="12">
                         <div v-if="!paymentValidations.instrucaoBoleto6.valid" class="invalid-message">Campo Obrigatório.</div>
                         </b-col>
                         </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 7:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 7', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 7'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto7" type="text" id="instrucaoBoleto7" maxlength="150" 
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto7.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.instrucaoBoleto7.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Instrução Boleto 8:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Instrução Boleto 8', 'Texto explicativo referente a instruçao do boleto')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Instrução Boleto 8'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.instrucaoBoleto8" type="text" id="instrucaoBoleto8" maxlength="150"
                        :class="'text-label required ' + (!paymentValidations.instrucaoBoleto8.valid ? 'is-invalid' : '')"
                         />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.instrucaoBoleto8.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Aceite:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Aceite', 'Código adotado pela FEBRABAN para identificar se o título de cobrança foi aceito (reconhecimento da dívida pelo Pagador) para o Título de Cobrança.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Aceite'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.aceite" type="text" id="aceite" maxlength="1" 
                        :class="'text-label required ' + (!paymentValidations.aceite.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.aceite.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <p class="mb-2">
                        Espécie do Documento:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Espécie do Documento', 'Espécie do documento.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Espécie do Documento'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.especieDocumentoBoleto" type="text" id="especieDocumentoBoleto" maxlength="5" 
                        :class="'text-label required ' + (!paymentValidations.especieDocumentoBoleto.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.especieDocumentoBoleto.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Código Chave Usuário Banco do Brasil:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Chave Usuário Banco do Brasil', 'Código chave do usuário do Banco do Brasil.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Chave Usuário Banco do Brasil'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoChaveUsuarioBb" type="text" id="codigoChaveUsuarioBb" maxlength="8" 
                        :class="'text-label required ' + (!paymentValidations.codigoChaveUsuarioBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoChaveUsuarioBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                        Indicador de Permissão de Recebimento:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Indicador de Permissão de Recebimento', 'Define o indicador de permissão de recebimento parcial do Título de Cobrança. N = titulo nao permite parcial.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Indicador de Permissão de Recebimento'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.indicadorPermissaoRecebimentoParcialBb" type="text" id="indicadorPermissaoRecebimentoParcialBb" maxlength="5" 
                        :class="'text-label required ' + (!paymentValidations.indicadorPermissaoRecebimentoParcialBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.indicadorPermissaoRecebimentoParcialBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <p class="mb-2">
                        Código Tipo Multa:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Tipo Multa', 'Código que define o valor de juros de mora que será aplicado, em caso de atraso no pagamento, ao Título de cobrança. - Se informado, `PERCENTUAL DE JUROS DO TÍTULO` deve ser ‘0’ (zero) e valor menor que `VALOR ORIGINAL DO TÍTULO`)')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Tipo Multa'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoTipoMultaBb" type="text" id="codigoTipoMultaBb" v-mask="['########']" 
                        :class="'text-label required ' + (!paymentValidations.codigoTipoMultaBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoTipoMultaBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Código Aceite Título:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Aceite Título', 'Código adotado pela FEBRABAN para identificar se o título de cobrança foi aceito (reconhecimento da dívida pelo Pagador) para o Título de Cobrança.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Aceite Título'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoAceiteTitulo" type="text" id="codigoAceiteTitulo" maxlength="1" 
                        :class="'text-label required ' + (!paymentValidations.codigoAceiteTitulo.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoAceiteTitulo.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <p class="mb-2">
                        Código Tipo Título:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Tipo Título', 'Código adotado pela FEBRABAN para identificar se o título de cobrança foi aceito (reconhecimento da dívida pelo Pagador) para o Título de Cobrança.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Tipo Título'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoTipoTituloBb" type="text" id="codigoTipoTituloBb" v-mask="['########']"
                        :class="'text-label required ' + (!paymentValidations.codigoTipoTituloBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoTipoTituloBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Código Tipo Conta Caução:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Tipo Conta Caução', 'Código que define tipo conta caução para o Título de Cobrança. Sempre 0.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Tipo Conta Caução'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoTipoContaCaucaoBb" type="text" id="codigoTipoContaCaucaoBb" v-mask="['########']"
                        :class="'text-label required ' + (!paymentValidations.codigoTipoContaCaucaoBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoTipoContaCaucaoBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="3">
                    <p class="mb-2">
                        Código Tipo Desconto:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Tipo Desconto', 'Código que define a ausência ou a forma como será concedido o desconto para o Título de Cobrança.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Tipo Desconto'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoTipoDescontoBb" type="text" id="codigoTipoDescontoBb" v-mask="['########']" 
                        :class="'text-label required ' + (!paymentValidations.codigoTipoDescontoBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoTipoDescontoBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="4">
                    <p class="mb-2">
                        Código Tipo Juros Mora:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Código Tipo Juros Mora', 'Código que define a ausência ou a forma como será concedido o desconto para o Título de Cobrança.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Código Tipo Juros Mora'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.codigoTipoJuromoraBb" type="text" id="codigoTipoJuromoraBb" v-mask="['########']"
                        :class="'text-label required ' + (!paymentValidations.codigoTipoJuromoraBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.codigoTipoJuromoraBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0 mt-4">
                <b-col sm="12" md="7">
                    <p class="mb-2">
                            Descrição Tipo Título:
                        <span class="text-danger">*</span>
                        <i class="fas fa-info-circle fa-12x text-info" variant="info"
                           @click="openInfo('Descrição Tipo Título', 'Descrição referente ao tipo do titulo adotado.')"
                           v-b-popover.hover.top="'Clique para saber mais sobre Descrição Tipo Título'"></i>
                    </p>
                    <b-form-group label>
                        <b-form-input v-model="parametros.descricaoTipoTituloBb" type="text" id="descricaoTipoTituloBb" maxlength="50" 
                        :class="'text-label required ' + (!paymentValidations.descricaoTipoTituloBb.valid ? 'is-invalid' : '')"
                        />
                        <b-row>
                        <b-col sm="12" md="12">
                        <div v-if="!paymentValidations.descricaoTipoTituloBb.valid" class="invalid-message">Campo Obrigatório.</div>
                        </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr class="mt-2"/>
            <b-row class="center-xy">
                <b-button variant="outline-secondary" v-b-modal.modal-voltar>
                    <i class="fa fa-reply"></i> Voltar
                </b-button>
                <b-button variant="primary" class="ml-2" @click="verificarSalvar">
                    <i class="far fa-save"></i> Salvar
                </b-button>
            </b-row>
        </b-card>
        <b-modal
                id="modal-voltar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Voltar"
                header-bg-variant="info"
                hea1w11111der-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja retornar à tela anterior sem salvar as alterações?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-voltar')"> Não</b-button>
                <b-button variant="primary" @click="voltar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja salvar as alterações?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')"> Não</b-button>
                <b-button variant="primary" @click="salvar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info"
                id="modal-info"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="titleInfo"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">{{textoInfo}}</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info')"> Fechar</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import axios from 'axios'
    import formatarMixins from '../../mixins/formatarMixins'
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {CompLoading},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                parametros: {
                    codParametro: 2,
                    nome: null,
                    endereco: null,
                    numero: null,
                    complementoEndereco: null,
                    bairro: null,
                    cep: null,
                    cidade: null,
                    uf: null,
                    contaCorrente: null,
                    dvContaCorrente: null,
                    agencia: null,
                    dvAgencia: null,
                    carteiraConvenioBb: null,
                    numeroConvenioBb: null,
                    cnpj: null,
                    localPagamento: null,
                    variacaoCarteira: null,
                    instrucaoBoleto1: null,
                    instrucaoBoleto2: null,
                    instrucaoBoleto3: null,
                    instrucaoBoleto4: null,
                    instrucaoBoleto5: null,
                    instrucaoBoleto6: null,
                    instrucaoBoleto7: null,
                    instrucaoBoleto8: null,
                    aceite: null,
                    especieDocumentoBoleto: null,
                    codigoChaveUsuarioBb: null,
                    codigoTipoMultaBb: null,
                    codigoAceiteTitulo: null,
                    codigoTipoTituloBb: null,
                    indicadorPermissaoRecebimentoParcialBb: null,
                    codigoTipoContaCaucaoBb: null,
                    codigoTipoDescontoBb: null,
                    codigoTipoJuromoraBb: null,
                    descricaoTipoTituloBb: null,
                    codigoModalidadeTituloBb: null,
                    telefone: null,
                },
                titleInfo: '',
                textoInfo: '',
                existeRegistro: false,
                editorOption: {
                    placeholder: '',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link', 'image', 'video']
                        ]
                    }
                },
                content: '',
                
                paymentValidations: {
                    nome: { valid: true, message: ""},
                    cnpj: { valid: true, message: ""},
                    cep: { valid: true, message: ""},
                    endereco: { valid: true, message: ""},
                    numero: { valid: true, message: ""},
                    complementoEndereco: { valid: true, message: ""},
                    bairro: { valid: true, message: ""},
                    uf: { valid: true, message: ""},
                    cidade: { valid: true, message: ""},
                    telefone: { valid: true, message: ""},
                    agencia: { valid: true, message: ""},
                    dvAgencia: { valid: true, message: ""},
                    contaCorrente: { valid: true, message: ""},
                    dvContaCorrente: { valid: true, message: ""},
                    numeroConvenioBb: { valid: true, message: ""},
                    carteiraConvenioBb: { valid: true, message: ""},
                    localPagamento: { valid: true, message: ""},
                    variacaoCarteira: { valid: true, message: ""},
                    codigoModalidadeTituloBb: { valid: true, message: ""},
                    instrucaoBoleto1: { valid: true, message: ""},
                    instrucaoBoleto2: { valid: true, message: ""},
                    instrucaoBoleto3: { valid: true, message: ""},
                    instrucaoBoleto4: { valid: true, message: ""},
                    instrucaoBoleto5: { valid: true, message: ""},
                    instrucaoBoleto6: { valid: true, message: ""},
                    instrucaoBoleto7: { valid: true, message: ""},
                    instrucaoBoleto8: { valid: true, message: ""},
                    aceite: { valid: true, message: ""},
                    especieDocumentoBoleto: { valid: true, message: ""},
                    codigoChaveUsuarioBb: { valid: true, message: ""},
                    indicadorPermissaoRecebimentoParcialBb: { valid: true, message: ""},
                    codigoTipoMultaBb: { valid: true, message: ""},
                    codigoAceiteTitulo: { valid: true, message: ""},
                    codigoTipoTituloBb: { valid: true, message: ""},
                    codigoTipoContaCaucaoBb: { valid: true, message: ""},
                    codigoTipoDescontoBb: { valid: true, message: ""},
                    codigoTipoJuromoraBb: { valid: true, message: ""},
                    descricaoTipoTituloBb: { valid: true, message: ""}
                  
                    
                    
                    
                },
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            verificarSalvar() {
                if(!this.validarNomeValorObrigatorio(this.nome)    | !this.validarcnpjValorObrigatorio(this.cnpj)| !this.validarCnpj(this.cnpj) |
                   !this.validarcepValorObrigatorio(this.cep)      | !this.validarenderecoValorObrigatorio(this.endereco) |
                   !this.validarnumeroValorObrigatorio(this.numero)| !this.validarcomplementoEnderecoValorObrigatorio(this.complementoEndereco) |
                   !this.validarbairroValorObrigatorio(this.bairro)| !this.validarufValorObrigatorio(this.uf) |
                   !this.validarcidadeValorObrigatorio(this.cidade)| !this.validartelefoneValorObrigatorio(this.telefone) |
                   !this.validaragenciaValorObrigatorio(this.agencia)| !this.validardvAgenciaValorObrigatorio(this.dvAgencia) |
                   !this.validarcontaCorrenteValorObrigatorio(this.contaCorrente) | !this.validardvContaCorrenteValorObrigatorio(this.dvContaCorrente) |
                   !this.validarnumeroConvenioBbValorObrigatorio(this.contaCorrente) | !this.validarcarteiraConvenioBbValorObrigatorio(this.dvContaCorrente) |
                   !this.validarnumerolocalPagamentoValorObrigatorio(this.localPagamento) | !this.validarcarteiravariacaoCarteiraValorObrigatorio(this.variacaoCarteira) |
                   !this.validarcodigoModalidadeTituloBbValorObrigatorio(this.codigoModalidadeTituloBb) | !this.validarinstrucaoBoleto1BbValorObrigatorio(this.instrucaoBoleto1) |
                   !this.validarinstrucaoBoleto2BbValorObrigatorio(this.instrucaoBoleto2) | !this.validarinstrucaoBoleto3BbValorObrigatorio(this.instrucaoBoleto3) |
                   !this.validarinstrucaoBoleto4BbValorObrigatorio(this.instrucaoBoleto4) | !this.validarinstrucaoBoleto5BbValorObrigatorio(this.instrucaoBoleto5) |
                   !this.validarinstrucaoBoleto6BbValorObrigatorio(this.instrucaoBoleto6) | !this.validarinstrucaoBoleto7BbValorObrigatorio(this.instrucaoBoleto7) |
                   !this.validarinstrucaoBoleto8BbValorObrigatorio(this.instrucaoBoleto8) | !this.validaraceiteValorObrigatorio(this.aceite) |
                   !this.validarespecieDocumentoBoletoValorObrigatorio(this.especieDocumentoBoleto) | !this.validarcodigoChaveUsuarioBbValorObrigatorio(this.codigoChaveUsuarioBb) |
                   !this.validarindicadorPermissaoRecebimentoParcialBbValorObrigatorio(this.indicadorPermissaoRecebimentoParcialBb) | !this.validarcodigoTipoMultaBbValorObrigatorio(this.codigoTipoMultaBb) |
                   !this.validarcodigoAceiteTituloValorObrigatorio(this.codigoAceiteTitulo) | !this.validarcodigoTipoTituloBbValorObrigatorio(this.codigoTipoTituloBb) |
                   !this.validarcodigoTipoContaCaucaoBbObrigatorio(this.codigoTipoContaCaucaoBb) | !this.validarcodigoTipoDescontoBbValorObrigatorio(this.codigoTipoDescontoBb) |
                   !this.validarcodigoTipoJuromoraBbObrigatorio(this.codigoTipoJuromoraBb) | !this.validardescricaoTipoTituloBbValorObrigatorio(this.descricaoTipoTituloBb)
                   ) {
                    return;

                }

                this.$refs['modal-salvar'].show();  



            },
            
            validarNomeValorObrigatorio() {
                
                if(this.parametros.nome == null | this.parametros.nome == "") {
                    this.validarCampoObrigatorio(this.parametros.nome, this.paymentValidations.nome)
                    return this.paymentValidations.nome.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.nome.valid=true;
                    
                }
                
             },   
             
              validarcnpjValorObrigatorio() {
             
                
                if(this.parametros.cnpj == null | this.parametros.cnpj == "") {
                    this.validarCampoObrigatorio(this.parametros.cnpj, this.paymentValidations.cnpj)
                    return this.paymentValidations.cnpj.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.cnpj.valid=true;
                    
                }
                
                },
                
                validarCnpj() {

	                if(this.parametros.cnpj != null && this.parametros.cnpj != "") {
	                	if(this.validarCnpjAlfanumerico(this.parametros.cnpj)) {
		                    return this.paymentValidations.cnpj.valid=true;
		                } else {
	                    	return this.paymentValidations.cnpj.valid=false;
	                    }
	                } else {
	                    return this.paymentValidations.cnpj.valid=false;
	                }

                },

                validarcepValorObrigatorio() {
                if(this.parametros.cep == null | this.parametros.cep == "") {
                    this.validarCampoObrigatorio(this.parametros.cep, this.paymentValidations.cep)
                    return this.paymentValidations.cep.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.cep.valid=true;
                    
                }
                },
                
                validarenderecoValorObrigatorio() {
                 if(this.parametros.endereco == null | this.parametros.endereco == "") {
                    this.validarCampoObrigatorio(this.parametros.endereco, this.paymentValidations.endereco)
                    return this.paymentValidations.endereco.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.endereco.valid=true;
                    
                }
                
                },
                
                validarnumeroValorObrigatorio() {
                 if(this.parametros.numero == null | this.parametros.numero == "") {
                    this.validarCampoObrigatorio(this.parametros.numero, this.paymentValidations.numero)
                    return this.paymentValidations.numero.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.numero.valid=true;
                    
                }
                
               }, 
                
               validarcomplementoEnderecoValorObrigatorio() {
                 if(this.parametros.complementoEndereco == null | this.parametros.complementoEndereco == "") {
                    this.validarCampoObrigatorio(this.parametros.complementoEndereco, this.paymentValidations.complementoEndereco)
                    return this.paymentValidations.complementoEndereco.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.complementoEndereco.valid=true;
                    
                }
                
               }, 
               
               validarbairroValorObrigatorio() {
                 if(this.parametros.bairro == null | this.parametros.bairro == "") {
                    this.validarCampoObrigatorio(this.parametros.bairro, this.paymentValidations.bairro)
                    return this.paymentValidations.bairro.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.bairro.valid=true;
                    
                }
                
               },
               
               validarufValorObrigatorio() {
                 if(this.parametros.uf == null | this.parametros.uf == "") {
                    this.validarCampoObrigatorio(this.parametros.uf, this.paymentValidations.uf)
                    return this.paymentValidations.uf.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.uf.valid=true;
                    
                }
                
               },
               
                  validarcidadeValorObrigatorio() {
                 if(this.parametros.cidade == null | this.parametros.cidade == "") {
                    this.validarCampoObrigatorio(this.parametros.cidade, this.paymentValidations.cidade)
                    return this.paymentValidations.cidade.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.cidade.valid=true;
                    
                }
                
               },
               
                 validartelefoneValorObrigatorio() {
                 if(this.parametros.telefone == null | this.parametros.telefone == "") {
                    this.validarCampoObrigatorio(this.parametros.telefone, this.paymentValidations.telefone)
                    return this.paymentValidations.telefone.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.telefone.valid=true;
                    
                }
                
               },
                   
                  validaragenciaValorObrigatorio() {
                 if(this.parametros.agencia == null | this.parametros.agencia == "") {
                    this.validarCampoObrigatorio(this.parametros.agencia, this.paymentValidations.agencia)
                    return this.paymentValidations.agencia.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.agencia.valid=true;
                    
                }
                
               },  
               
                  validardvAgenciaValorObrigatorio() {
                 if(this.parametros.dvAgencia == null | this.parametros.dvAgencia == "") {
                    this.validarCampoObrigatorio(this.parametros.dvAgencia, this.paymentValidations.dvAgencia)
                    return this.paymentValidations.dvAgencia.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.dvAgencia.valid=true;
                    
                }
                
               },
               
               validarcontaCorrenteValorObrigatorio() {
                 if(this.parametros.contaCorrente == null | this.parametros.contaCorrente == "") {
                    this.validarCampoObrigatorio(this.parametros.contaCorrente, this.paymentValidations.contaCorrente)
                    return this.paymentValidations.contaCorrente.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.contaCorrente.valid=true;
                    
                }
                
               },
               
                validardvContaCorrenteValorObrigatorio() {
                 if(this.parametros.dvContaCorrente == null | this.parametros.dvContaCorrente == "") {
                    this.validarCampoObrigatorio(this.parametros.dvContaCorrente, this.paymentValidations.dvContaCorrente)
                    return this.paymentValidations.dvContaCorrente.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.dvContaCorrente.valid=true;
                    
                }
                
               },
               
                validarnumeroConvenioBbValorObrigatorio() {
                 if(this.parametros.numeroConvenioBb == null | this.parametros.numeroConvenioBb == "") {
                    this.validarCampoObrigatorio(this.parametros.numeroConvenioBb, this.paymentValidations.numeroConvenioBb)
                    return this.paymentValidations.numeroConvenioBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.numeroConvenioBb.valid=true;
                    
                }
                
               },
               
                validarcarteiraConvenioBbValorObrigatorio() {
                 if(this.parametros.carteiraConvenioBb == null | this.parametros.carteiraConvenioBb == "") {
                    this.validarCampoObrigatorio(this.parametros.carteiraConvenioBb, this.paymentValidations.carteiraConvenioBb)
                    return this.paymentValidations.carteiraConvenioBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.carteiraConvenioBb.valid=true;
                    
                }
                
               },
                 
                  validarnumerolocalPagamentoValorObrigatorio() {
                 if(this.parametros.localPagamento == null | this.parametros.localPagamento == "") {
                    this.validarCampoObrigatorio(this.parametros.localPagamento, this.paymentValidations.localPagamento)
                    return this.paymentValidations.localPagamento.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.localPagamento.valid=true;
                    
                }
                
               },    
               
                 validarcarteiravariacaoCarteiraValorObrigatorio() {
                 if(this.parametros.variacaoCarteira == null | this.parametros.variacaoCarteira == "") {
                    this.validarCampoObrigatorio(this.parametros.variacaoCarteira, this.paymentValidations.variacaoCarteira)
                    return this.paymentValidations.variacaoCarteira.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.variacaoCarteira.valid=true;
                    
                }
                
               },    
               
               validarcodigoModalidadeTituloBbValorObrigatorio() {
                 if(this.parametros.codigoModalidadeTituloBb == null | this.parametros.codigoModalidadeTituloBb == "") {
                    this.validarCampoObrigatorio(this.parametros.codigoModalidadeTituloBb, this.paymentValidations.codigoModalidadeTituloBb)
                    return this.paymentValidations.codigoModalidadeTituloBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoModalidadeTituloBb.valid=true;
                    
                }
                
               }, 
               
                  validarinstrucaoBoleto1BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto1 == null | this.parametros.instrucaoBoleto1 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto1, this.paymentValidations.instrucaoBoleto1)
                    return this.paymentValidations.instrucaoBoleto1.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto1.valid=true;
                    
                }
                
               },  
               
                 validarinstrucaoBoleto2BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto2 == null | this.parametros.instrucaoBoleto2 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto2, this.paymentValidations.instrucaoBoleto2)
                    return this.paymentValidations.instrucaoBoleto2.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto2.valid=true;
                    
                }
                
               },
               
               
                validarinstrucaoBoleto3BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto3 == null | this.parametros.instrucaoBoleto3 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto3, this.paymentValidations.instrucaoBoleto3)
                    return this.paymentValidations.instrucaoBoleto3.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto3.valid=true;
                    
                }
                
               },   
               
               
                validarinstrucaoBoleto4BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto4 == null | this.parametros.instrucaoBoleto4 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto4, this.paymentValidations.instrucaoBoleto4)
                    return this.paymentValidations.instrucaoBoleto4.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto4.valid=true;
                    
                }
                
               },
               
                validarinstrucaoBoleto5BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto5 == null | this.parametros.instrucaoBoleto5 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto5, this.paymentValidations.instrucaoBoleto5)
                    return this.paymentValidations.instrucaoBoleto5.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto5.valid=true;
                    
                }
                
               },
               
                validarinstrucaoBoleto6BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto6 == null | this.parametros.instrucaoBoleto6 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto6, this.paymentValidations.instrucaoBoleto6)
                    return this.paymentValidations.instrucaoBoleto6.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto6.valid=true;
                    
                }
                
               },
               
                validarinstrucaoBoleto7BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto7 == null | this.parametros.instrucaoBoleto7 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto7, this.paymentValidations.instrucaoBoleto7)
                    return this.paymentValidations.instrucaoBoleto7.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto7.valid=true;
                    
                }
                
               },
               
                validarinstrucaoBoleto8BbValorObrigatorio() {
                 if(this.parametros.instrucaoBoleto8 == null | this.parametros.instrucaoBoleto8 == "") {
                    this.validarCampoObrigatorio(this.parametros.instrucaoBoleto8, this.paymentValidations.instrucaoBoleto8)
                    return this.paymentValidations.instrucaoBoleto8.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.instrucaoBoleto8.valid=true;
                    
                }
                
               },
               
                validaraceiteValorObrigatorio() {
                 if(this.parametros.aceite == null | this.parametros.aceite == "") {
                    this.validarCampoObrigatorio(this.parametros.aceite, this.paymentValidations.aceite)
                    return this.paymentValidations.aceite.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.aceite.valid=true;
                    
                }
                
               },
               
               validarespecieDocumentoBoletoValorObrigatorio() {
                 if(this.parametros.especieDocumentoBoleto == null | this.parametros.especieDocumentoBoleto == "") {
                    this.validarCampoObrigatorio(this.parametros.especieDocumentoBoleto, this.paymentValidations.especieDocumentoBoleto)
                    return this.paymentValidations.especieDocumentoBoleto.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.especieDocumentoBoleto.valid=true;
                    
                }
                
               },
               
               validarcodigoChaveUsuarioBbValorObrigatorio() {
                 if(this.parametros.codigoChaveUsuarioBb == null | this.parametros.codigoChaveUsuarioBb == "") {
                    this.validarCampoObrigatorio(this.parametros.codigoChaveUsuarioBb, this.paymentValidations.codigoChaveUsuarioBb)
                    return this.paymentValidations.codigoChaveUsuarioBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoChaveUsuarioBb.valid=true;
                    
                }
                
               },
                    
                
               validarindicadorPermissaoRecebimentoParcialBbValorObrigatorio() {
                 if(this.parametros.indicadorPermissaoRecebimentoParcialBb == null | this.parametros.indicadorPermissaoRecebimentoParcialBb == "") {
                    this.validarCampoObrigatorio(this.parametros.indicadorPermissaoRecebimentoParcialBb, this.paymentValidations.indicadorPermissaoRecebimentoParcialBb)
                    return this.paymentValidations.indicadorPermissaoRecebimentoParcialBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.indicadorPermissaoRecebimentoParcialBb.valid=true;
                    
                }
                
               },  
               
               validarcodigoTipoMultaBbValorObrigatorio() {
                 if(this.parametros.codigoTipoMultaBb == null | this.parametros.codigoTipoMultaBb == "" ) {
                    this.validarCampoObrigatorio(this.parametros.codigoTipoMultaBb, this.paymentValidations.codigoTipoMultaBb)
                    return this.paymentValidations.codigoTipoMultaBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoTipoMultaBb.valid=true;
                    
                }
                
               }, 
               
               validarcodigoAceiteTituloValorObrigatorio() {
                 if(this.parametros.codigoAceiteTitulo == null | this.parametros.codigoAceiteTitulo == "") {
                    this.validarCampoObrigatorio(this.parametros.codigoAceiteTitulo, this.paymentValidations.codigoAceiteTitulo)
                    return this.paymentValidations.codigoAceiteTitulo.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoAceiteTitulo.valid=true;
                    
                }
                
               },  
               
               validarcodigoTipoTituloBbValorObrigatorio() {
                 if(this.parametros.codigoTipoTituloBb == null | this.parametros.codigoTipoTituloBb == "") {
                    this.validarCampoObrigatorio(this.parametros.codigoTipoTituloBb, this.paymentValidations.codigoTipoTituloBb)
                    return this.paymentValidations.codigoTipoTituloBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoTipoTituloBb.valid=true;
                    
                }
                
               },  
                
                validarcodigoTipoContaCaucaoBbObrigatorio() {
                 if(this.parametros.codigoTipoContaCaucaoBb === null | this.parametros.codigoTipoContaCaucaoBb === "") {
                    this.validarCampoObrigatorio(this.parametros.codigoTipoContaCaucaoBb, this.paymentValidations.codigoTipoContaCaucaoBb)
                    return this.paymentValidations.codigoTipoContaCaucaoBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoTipoContaCaucaoBb.valid=true;
                    
                }
                
               },   
               
                validarcodigoTipoDescontoBbValorObrigatorio() {
                 if(this.parametros.codigoTipoDescontoBb === null | this.parametros.codigoTipoDescontoBb === "") {
                    this.validarCampoObrigatorio(this.parametros.codigoTipoDescontoBb, this.paymentValidations.codigoTipoDescontoBb)
                    return this.paymentValidations.codigoTipoDescontoBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoTipoDescontoBb.valid=true;
                    
                }
                
               }, 
                   
                   validarcodigoTipoJuromoraBbObrigatorio() {
                 if(this.parametros.codigoTipoJuromoraBb === null | this.parametros.codigoTipoJuromoraBb === "") {
                    this.validarCampoObrigatorio(this.parametros.codigoTipoJuromoraBb, this.paymentValidations.codigoTipoJuromoraBb)
                    return this.paymentValidations.codigoTipoJuromoraBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.codigoTipoJuromoraBb.valid=true;
                    
                }
                
               },  
               
               
                  validardescricaoTipoTituloBbValorObrigatorio() {
                 if(this.parametros.descricaoTipoTituloBb === null | this.parametros.descricaoTipoTituloBb === "") {
                    this.validarCampoObrigatorio(this.parametros.descricaoTipoTituloBb, this.paymentValidations.descricaoTipoTituloBb)
                    return this.paymentValidations.descricaoTipoTituloBb.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.descricaoTipoTituloBb.valid=true;
                    
                }
                
               }, 
                   

            salvar() {
                this.$refs['modal-salvar'].hide();

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/parametrosCES/salvar`, this.parametros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(() => {
                    this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!!');
                    this.$router.push({path: '/home'});
                    window.scrollTo(0,0);
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            openInfo(title, text) {
                this.titleInfo = title;
                this.textoInfo = text;
                this.$refs['modal-info'].show();
            },

            verificarObrigatoriedade() {
                return !(this.verificarValorVazio(this.parametros.nome) ||
                    this.verificarValorVazio(this.parametros.endereco) ||
                    this.verificarValorVazio(this.parametros.numero) ||
                    this.verificarValorVazio(this.parametros.complementoEndereco) ||
                    this.verificarValorVazio(this.parametros.bairro) ||
                    this.verificarValorVazio(this.parametros.cep) ||
                    this.verificarValorVazio(this.parametros.cidade) ||
                    this.verificarValorVazio(this.parametros.uf) ||
                    this.verificarValorVazio(this.parametros.contaCorrente) ||
                    this.verificarValorVazio(this.parametros.dvContaCorrente) ||
                    this.verificarValorVazio(this.parametros.agencia) ||
                    this.verificarValorVazio(this.parametros.dvAgencia) ||
                    this.verificarValorVazio(this.parametros.carteiraConvenioBb) ||
                    this.verificarValorVazio(this.parametros.numeroConvenioBb) ||
                    this.verificarValorVazio(this.parametros.cnpj) ||
                    this.verificarValorVazio(this.parametros.localPagamento) ||
                    this.verificarValorVazio(this.parametros.variacaoCarteira) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto1) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto2) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto3) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto4) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto5) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto6) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto7) ||
                    this.verificarValorVazio(this.parametros.instrucaoBoleto8) ||
                    this.verificarValorVazio(this.parametros.aceite) ||
                    this.verificarValorVazio(this.parametros.especieDocumentoBoleto) ||
                    this.verificarValorVazio(this.parametros.codigoChaveUsuarioBb) ||
                    this.verificarValorVazio(this.parametros.codigoTipoMultaBb) ||
                    this.verificarValorVazio(this.parametros.codigoAceiteTitulo) ||
                    this.verificarValorVazio(this.parametros.codigoTipoTituloBb) ||
                    this.verificarValorVazio(this.parametros.indicadorPermissaoRecebimentoParcialBb) ||
                    this.verificarValorVazio(this.parametros.codigoTipoContaCaucaoBb) ||
                    this.verificarValorVazio(this.parametros.codigoTipoDescontoBb) ||
                    this.verificarValorVazio(this.parametros.codigoTipoJuromoraBb) ||
                    this.verificarValorVazio(this.parametros.descricaoTipoTituloBb) ||
                    this.verificarValorVazio(this.parametros.codigoModalidadeTituloBb) ||
                    this.verificarValorVazio(this.parametros.telefone));
            },

            voltar(evt) {
                evt.preventDefault();
                this.$router.push({path: '/'});
            },

            async obterParametro() {
                await axios.get(`${this.urlApi}/v1/parametrosCES`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.parametros = response.data;
                    this.parametros.codParametro = response.data.codParametro ? response.data.codParametro : 2;
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.obterParametro();
        }
    }
</script>
<style>
    .text-danger {
        margin-right: 10px;
    }
</style>